import { useCallback, useRef, useState } from 'react';

export default function useCountDown() {
  const [time, setTime] = useState(-1);

  const currentTimer = useRef<number>(0);
  const reset = useCallback((total: number) => {
    setTime(Math.floor(total));
    currentTimer.current = window.setInterval(() => {
      setTime((old) => {
        if (old <= 0) {
          window.clearInterval(currentTimer.current);
          return -1;
        } else {
          return old - 1;
        }
      });
    }, 1000);
  }, []);

  const clear = useCallback(() => {
    clearInterval(currentTimer.current);
  }, [currentTimer]);

  return {
    time,
    reset,
    clear,
  };
}
